import React from 'react';
import { useTranslation } from 'next-i18next';
import Icon from '@components/atoms/icon/icon';
import styles from './filters.module.scss';
import Search from './search/search';
import DateFilter from './date/date-filter';

export type FilterType = 'search' | 'date';

interface FilterProps {
  onChange: (v: FilterType) => void;
  filterType: FilterType;
  currentPage: number;
  onProductIdChange: (ids: number[]) => void;
  setMoreSearch: (v: boolean) => void;
  setSubmittedSearchText: (v: string) => void;
  setSearchFetching: (v: boolean) => void;
  setSearchEmpty: (v: boolean) => void;
  onDateChange: ({ fromDate, toDate }: { fromDate: string; toDate: string }) => void;
}

const Filters = ({
  onChange,
  filterType,
  currentPage,
  onProductIdChange,
  setMoreSearch,
  setSubmittedSearchText,
  setSearchFetching,
  setSearchEmpty,
  onDateChange,
}: FilterProps) => {
  const { t } = useTranslation('orders-sales');
  const { t: tA11y } = useTranslation('a11y');

  const filerOptions: Array<{ value: FilterType; label: string }> = [
    {
      value: 'search',
      label: t('MY_ACCOUNT.ORDERS_SALES.LIST.SEARCH.KEYWORD'),
    },
    {
      value: 'date',
      label: t('MY_ACCOUNT.ORDERS_SALES.LIST.SEARCH.DATE'),
    },
  ];

  return (
    <>
      <div className={styles.filters}>
        <div>{t('MY_ACCOUNT.ORDERS_SALES.LIST.SEARCH_BY')}</div>

        <div className={styles.select}>
          <select onChange={(e) => onChange(e.target.value as FilterType)}>
            {filerOptions.map(({ value, label }) => {
              return (
                <option
                  key={value}
                  value={value}
                >
                  {label}
                </option>
              );
            })}
          </select>
          <Icon
            name="arrow-head-down"
            className={styles.select_icon}
            ariaLabel={tA11y('A11Y.ICON.DROPDOWN_DOWN')}
          />
        </div>
      </div>
      {filterType === 'search' ? (
        <Search
          currentPage={currentPage}
          onProductIdChange={onProductIdChange}
          setMoreSearch={setMoreSearch}
          setSubmittedSearchText={setSubmittedSearchText}
          setSearchFetching={setSearchFetching}
          setSearchEmpty={setSearchEmpty}
        />
      ) : (
        <DateFilter onDateChange={onDateChange} />
      )}
    </>
  );
};

export default Filters;
